<h2 mat-dialog-title>Edit Proficiency Result</h2>
<form [formGroup]="form">
  <mat-dialog-content [formGroup]="form">
    <div class="flex flex-col">
      <mat-form-field>
        <mat-label>Year</mat-label>
        <input matInput formControlName="Year">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Period</mat-label>
        <input matInput formControlName="Period">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Percent</mat-label>
        <input matInput formControlName="PtPercent">
        <mat-error *ngIf="form.get('PtPercent').invalid">
          A number between 0 and 100
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Evaluator</mat-label>
        <mat-select formControlName="Evaluator">
          <mat-option value=""></mat-option>
          <mat-option *ngFor="let evaluator of eval" [value]="evaluator.code">{{evaluator.code}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Comments</mat-label>
        <textarea matInput cdkTextareaAutosize formControlName="Comments"></textarea>
        <mat-error *ngIf="form.get('Comments').invalid">
          Cannot be longer than 4000 characters.
        </mat-error>
      </mat-form-field>
    </div>
    <div class="flex flex-row padding10">
      <div style="padding-right: 20px;">
        <button mat-raised-button (click)="close()">Cancel</button>        
      </div>      
      <div style="padding-right: 20px;">
        <button mat-raised-button color="warn" (click)="delete()">Delete</button>
      </div>
      <div>
        <button mat-raised-button color="primary" (click)="save()">Save</button>
      </div>
    </div>  
  </mat-dialog-content>
</form>


